import React from 'react';

function Heading1({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M 4 6, v 12" />
      <path d="M 13 6, v 12" />
      <path d="M 4.5 12, h 8" />
      <path d="M 17.5 12.5, l 2.5 -2" />
      <path d="M 20 10.5, v 7.5" />
    </svg>
  );
}

export default Heading1;
